import React from "react";
import "./logo.scss";

/**
 * NextFlip logo — location-pin icon with an embedded upward-trend line,
 * plus the wordmark. The icon communicates "smart deal discovery."
 *
 * @param {object} props
 * @param {'light'|'dark'} props.variant - 'light' = white text, 'dark' = dark text
 */
const Logo = ({ variant = "dark" }) => (
  <span className={`logo logo--${variant}`}>
    <svg
      className="logo-icon"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <defs>
        <linearGradient
          id="nextflip-grad"
          x1="0"
          y1="0"
          x2="32"
          y2="32"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0%" stopColor="#E4572E" />
          <stop offset="100%" stopColor="#F07858" />
        </linearGradient>
      </defs>
      {/* Pin body — rounded teardrop shape */}
      <path
        d="M16 2C10.48 2 6 6.48 6 12c0 7.5 10 18 10 18s10-10.5 10-18c0-5.52-4.48-10-10-10z"
        fill="url(#nextflip-grad)"
      />
      {/* Upward trend line inside the pin */}
      <polyline
        points="11,15 14,11 17.5,13.5 22,8"
        stroke="#ffffff"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      {/* Arrow tip on the trend */}
      <polyline
        points="19.5,8 22,8 22,10.5"
        stroke="#ffffff"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
    </svg>
    <span className="logo-wordmark">NextFlip</span>
  </span>
);

export default Logo;
